import { Controller } from '@hotwired/stimulus';
import lottie from 'lottie-web';
import getAnimationData from '../utils/get_animation_data';

export default class ActionItemCheckmarkController extends Controller {
  static targets = ['actionItem', 'checkmark'];
  static values = {
    iconUrl: String
  };

  lottieCheck = null;
  observer = null;
  observerOptions = {
    attributes: true,
    childList: false,
    subtree: false,
    attributeFilter: ['data-completed']
  };

  get itemCompleted() {
    return this.actionItemTarget.dataset.completed === 'true';
  }

  initialize() {
    this.loadCheckmark();
    this.createObserver();
  }

  async loadCheckmark() {
    const animationData = await getAnimationData(this.iconUrlValue);
    this.lottieCheck = lottie.loadAnimation({
      container: this.checkmarkTarget,
      autoplay: false,
      loop: false,
      animationData: animationData
    });
    this.setInitialState();
  }

  setInitialState() {
    if (this.itemCompleted) {
      this.goToAnimationEndAndStop();
    }
  }

  createObserver() {
    this.observer = new MutationObserver(this.onAttributeChanged.bind(this));
    this.observer.observe(this.actionItemTarget, this.observerOptions);
  }

  onAttributeChanged(attributeMutationList) {
    const isCompletedAttributePresent = attributeMutationList.find(
      (x) => x.type === 'attributes' && x.attributeName === 'data-completed'
    );
    if (isCompletedAttributePresent && this.itemCompleted) {
      this.goToAnimationBeginningAndPlay();
    }
  }

  goToAnimationEndAndStop() {
    this.lottieCheck.goToAndStop(this.lottieCheck.totalFrames - 1, true);
  }

  goToAnimationBeginningAndPlay() {
    this.lottieCheck.goToAndPlay(0, true);
  }

  disconnect() {
    this.observer.disconnect();
  }
}
